<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title" id="Ack">ACKNOWLEDGEMENTS</p>
<p class="noindent">I would like to thank the Trusty Techs of Shallotte, North Carolina, for their excellent work on designing the website for the Moonlight Mill Murders of Steubenville, Ohio, for getting it up and running and for the technical work with the photographs within this book. Visit their website at www.trustytechs.com.</p>
<p class="indent">I would also like to thank my son, David Guy Jr., for his support and assistance with the book.</p>
<p class="indent">My thanks also goes to Jimmy Bee, the owner of Beez Custom Paints of Wintersville, Ohio. His awesome artwork has brought life to the story.</p>
<p class="indent">I would like to say thank you to the Oak Ridge Inn of Walnut Creek, Ohio, for its beautiful, peaceful surroundings that allowed me to break through the writer’s block and let the words flow—it’s what this gal needed, so I will be back!</p>
<p class="indent">I would also like to say a great big thank you to the <i>Steubenville Herald Star</i> for its permission to use various photographs and for its excellent reporting of this story at the time it happened.  </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?7599706b